import React from 'react';
import PropTypes from 'prop-types';

import { StyledInput } from './styles';

const Input = ({
  className,
  ...props
}) => <StyledInput className={className} {...props} />;

Input.propTypes = {
  className: PropTypes.string,
};

Input.defaultProps = {
  className: '',
};

export default Input;
